<template>
  <!-- <div class="site-contents dashboard d-flex align-items-center flex-wrap">
  <div class="container">-->
  <div class="events-wrap d-flex flex-wrap justify-content-between">
    <div
      class="modal fade form-wrapper"
      id="create"
      tabindex="-1"
      role="dialog"
      aria-labelledby="gift-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document" id="gift-modal">
        <div class="modal-content form-content">
          <div class="modal-body">
            <img
              class="close"
              src="../../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
              @click="resetGiftForm()"
            />
            <template v-if="searchGiftFromWeb == false && addCustomGift == false">
              <div class="create-form web-search-form">
                <div class="form-group first-button">
                  <button class="btn btn-primary form-control" @click="searchGift()" type="button">
                    <i class="fa fa-plus"></i> Add Gift From Web URL
                  </button>
                </div>
                <div class="form-group">
                  <button class="btn btn-primary form-control" @click="customGift()" type="button">
                    <i class="fa fa-plus"></i> Add Custom Gift
                  </button>
                </div>
              </div>
            </template>
            <template>
              <form id="addGiftFromWebForm" @submit.prevent="addGiftFromWeb()">
                <div
                  class="create-form web-search-form"
                  v-if="searchGiftFromWeb && addCustomGift == false"
                >
                  <div class="form-group first-button">
                    <input
                      type="text"
                      v-model="webLink"
                      name="webLink"
                      ref="webLink"
                      class="form-control"
                      v-validate="'webLinkValidate|required'"
                      placeholder="Copy and paste the URL to the gift's page."
                      v-bind:class="{ 'is-invalid': errors.has('webLink')}"
                      :disabled="disabled == true"
                    />
                    <div class="invalid-feedback">{{ errors.first('webLink') }}</div>
                  </div>
                  <div class="form-group">
                    <div
                      class="alert alert-success alert-dismissible"
                      :show="dismissCountDown"
                      dismissible
                      variant="success"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged"
                      v-if="apiSuccessMessage!=null"
                    >{{ apiSuccessMessage }}</div>
                    <div
                      class="alert alert-danger alert-dismissible"
                      :show="dismissCountDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged"
                      v-else-if="apiErrorMessage!=null"
                    >{{ apiErrorMessage }}</div>
                    <div
                      v-if="(showSpinner === true)"
                      class="spinner-border"
                      style="width: 3rem; height: 3rem;color:#FD3E75;top:50%;left:50%"
                      role="status"
                    ></div>
                    <button
                      class="btn btn-primary"
                      type="submit"
                      :disabled="disabled == true"
                    >{{ buttonText }}</button>
                  </div>
                </div>
              </form>
              <div v-if="addCustomGift && searchGiftFromWeb == false">
                <input
                  type="file"
                  ref="file"
                  style="display: none"
                  v-on:change="handleFileUpload()"
                />

                <div class="img-upload d-flex flex-wrap align-items-center justify-content-center">
                  <img
                    v-if="imagePreview == null"
                    class="image-upload-icon"
                    src="../../../public/assets/images/upload.svg"
                    @click="$refs.file.click()"
                  />
                  <img
                    v-if="imagePreview == null"
                    src="../../../public/assets/images/plus.svg"
                    @click="$refs.file.click()"
                  />
                  <img v-if="cropped" v-bind:src="cropped" :class="{fullHeight:cropped != null}" />
                  <vue-croppie
                    v-show="imagePreview !== null && imagePreview !== ''"
                    ref="croppieRef"
                    :enableOrientation="true"
                    :enforceBoundary="true"
                    :enableResize="false"
                    :enableExif="true"
                    @result="result"
                    @update="update"
                    :mouseWheelZoom="false"
                    :showZoomer="true"
                    :viewport="{ width: 322, height: 215, type: 'square' }"
                    :boundry="{ width: 600, height: 430}"
                  ></vue-croppie>

                  <button
                    v-if="imagePreview && !cropped"
                    class="btn btn-primary crop-button"
                    @click="cancelBanner()"
                  >
                    <i class="fa fa-times"></i>
                    Cancel
                  </button>
                  <button
                    v-if="cropped || cancelImage"
                    class="btn btn-primary crop-button"
                    @click="$refs.file.click()"
                  >
                    <i class="fa fa-upload"></i>
                    Change banner
                  </button>
                  <button
                    v-if="imagePreview && !cropped"
                    class="btn btn-primary crop-button crop"
                    style="right : 180px"
                    @click="crop()"
                  >Crop</button>
                </div>
                <div class="create-form">
                  <!-- <div
                    class="gcse-searchbox"
                    data-enable-history="true"
                    data-auto-complete-max-completions="5"
                    data-auto-complete-match-type="any"
                  ></div>
                  <div class="gcse-searchresults" data-refinement-style="link"></div>-->
                  <form class="addGiftForm" id="addGift">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="giftName"
                        id="gname"
                        data-vv-as="gift name"
                        v-model="giftName"
                        v-validate="{required:true, min:1, max:500 /*regex:/^[A-Z][a-z]{0,49}$/*/}"
                        ref="giftName"
                        v-bind:class="{ 'is-invalid': errors.has('giftName')}"
                        placeholder="Gift Name"
                      />
                      <div class="invalid-feedback">{{ errors.first('giftName') }}</div>
                    </div>

                    <div class="form-group">
                      <label for="cname">Desirability</label>
                      <div class="select-details">
                        <select class="form-control" v-model="want">

                          <option value="">No Preference</option>
                          <option>Useful</option>
                          <option>Wants</option>
                          <option>Really Wants</option>
                          <option>Must Have</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="cname">More details</label>
                      <textarea
                        type="text"
                        class="form-control"
                        id="buydetails"
                        name="buydetails"
                        placeholder="Max 250 words"
                        data-vv-as="more details"
                        v-model="buydetails"
                        v-validate="'min:3|max:250'"
                        ref="buydetails"
                        v-bind:class="{ 'is-invalid': errors.has('buydetails')}"
                      ></textarea>
                      <span class="text-right">{{ detailCharacterCount }} / 250</span>
                      <div class="invalid-feedback">{{ errors.first('buydetails') }}</div>
                    </div>
                    <div class="form-group">
                      <label for="detail">Price</label>
                      <input
                        type="text"
                        class="form-control"
                        id="buyPrice"
                        name="buyPrice"
                        placeholder="$"
                        data-vv-as="product price"
                        v-model="buyPrice"
                        v-validate="'priceFormat|min:0'"
                        ref="buyPrice"
                        v-bind:class="{ 'is-invalid': errors.has('buyPrice')}"
                      />

                      <div class="invalid-feedback">{{ errors.first('buyPrice') }}</div>
                    </div>
                    <div class="form-group">
                      <label for="date">Quantity</label>
                      <input
                        type="number"
                        class="form-control"
                        id="buyQty"
                        name="buyQty"
                        placeholder="how many?"
                        data-vv-as="quantity"
                        v-model="buyQty"
                        v-validate="'required|numeric'"
                        ref="buyQty"
                        v-bind:class="{ 'is-invalid': errors.has('buyQty')}"
                      />
                      <div class="invalid-feedback">{{ errors.first('buyQty') }}</div>
                    </div>

                    <div class="form-group">
                      <label for="date">Size</label>
                      <input
                        type="text"
                        class="form-control"
                        id="buySize"
                        name="buySize"
                        placeholder="Enter size"
                        data-vv-as="size"
                        v-model="buySize"
                        v-validate="'min:1|productSizeFormat'"
                        ref="buySize"
                        v-bind:class="{ 'is-invalid': errors.has('buySize')}"
                      />
                      <div class="invalid-feedback">{{ errors.first('buySize') }}</div>
                    </div>
                    <!--<div class="form-group">
                      <label for="date">Colour</label>
                      <input
                        type="text"
                        class="form-control"
                        id="buyColor"
                        name="buyColor"
                        placeholder="e.g. blue"
                        data-vv-as="colour"
                        v-model="buyColor"
                        v-validate="'min:3|max:50'"
                        ref="buyColor"
                        v-bind:class="{ 'is-invalid': errors.has('buyColor')}"
                      />
                      <div class="invalid-feedback">{{ errors.first('buyColor') }}</div>
                    </div>
                    -->
                    <div class="form-group">
                      <label for="toBuy">Where to buy</label>
                      <input
                        type="text"
                        class="form-control"
                        id="buyPlace"
                        name="buyPlace"
                        placeholder="Amazon"
                        data-vv-as="where to buy"
                        v-model="buyPlace"
                        v-validate="'min:3'"
                        ref="buyPlace"
                        v-bind:class="{ 'is-invalid': errors.has('buyPlace')}"
                      />
                      <div class="invalid-feedback">{{ errors.first('buyPlace') }}</div>
                    </div>

                    <div class="modal-footer form-footer justify-content-start flex-wrap">
                      <div
                        class="alert alert-success alert-dismissible"
                        :show="dismissCountDown"
                        dismissible
                        variant="success"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                        v-if="apiSuccessMessage!=null"
                      >{{apiSuccessMessage}}</div>
                      <div
                        class="alert alert-danger alert-dismissible"
                        :show="dismissCountDown"
                        dismissible
                        variant="danger"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                        v-else-if="apiErrorMessage!=null"
                      >{{apiErrorMessage}}</div>

                      <a
                        href="#"
                        data-dismiss="modal"
                        class="cancel-gift-addition"
                        @click="resetGiftForm()"
                      >Cancel gift</a>
                      <div
                        v-if="(showSpinner === true)"
                        class="spinner-border"
                        style="width: 3rem; height: 3rem;color:#FD3E75;"
                        role="status"
                      ></div>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addGiftMethod"
                        :disabled="disabled == true"
                      >{{ buttonText }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!--select Images-->
   <!-- Modal -->
    <div id="selectImagesModal" class="modal fade form-wrapper" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="selectImagesModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="selectImagesModalLabel">Select image</h3>
           <!--  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
             -->
          </div>
          <div class="modal-body">
            <div class="container">
            <div class="row">
              <div v-for="img in selectImages" class="col-md-3 py-3">
                <img style="border:1px solid #ccc; width:100%; max-height:200px;cursor:pointer;" :src="img" />
              </div>
            </div>
            </div>
           
           
          </div>
          
        </div>
      </div>
    </div>
      <!--select Images-->

    </div>
    <!-- <list-gift v-if="searchGiftFromWeb && addCustomGift"></list-gift> -->
  </div>
  <!-- </div>
  </div>-->
</template>

<style>
.crop-button {
  margin-left: 500px;
  margin-top: 10px;
}
#selectImagesModal .row img:hover{
  border:1px solid #6d589b !important;
}
#selectImagesModal{
  min-height:100%;
  border:1px solid #6d589b !important;
  border-radius:25px;
}
#selectImagesModal .modal-header{
  border-bottom:1px solid #ccc !important;
  background:#fff !important;
}
#selectImagesModal .modal-content{ 
  min-height:600px;
  overflow-y:auto;
}
</style>

<script>
import Vue from "vue";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
import isURL from "validator/lib/isURL";

import {
  UPLOAD_GIFT_IMAGE,
  ADD_GIFT,
  GET_META_DATA,
  SET_GIFT_DETAILS
} from "../../store/gift/action.type";
import ListGift from "../gift/ListGift";

Vue.use(VueCroppie);

export default {
  data() {
    return {
      apiErrorMessage: null,
      apiSuccessMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      showSpinner: null,
      disabled: false,

      //for popups
      addCustomGift: false,
      searchGiftFromWeb: false,
      webLink: null,
      webImage: null,
      selectImages : [],

      /* gift */
      giftName: "",
      buyPlace: "",
      buyColor: "",
      buySize: "",
      buyQty: "",
      buyPrice: "",
      buydetails: "",
      want: "",
      image: "",
      buttonText: "+ Add Gift",

      /* for croppie */
      cropped: null,
      file: "",
      showPreview: false,
      imagePreview: null,
      cancelImage: false,

      showAddGiftOptionModal: false
    };
  },
  computed: {
    detailCharacterCount() {
      let char = this.buydetails;
      if (char) {
        return char.length;
      } else {
        return 0;
      }
    }
  },

  props: {
    show: Boolean
  },
  mounted() {
    let self = this;
    $('body').on('click','#selectImagesModal .row img',function(){
      
      let selectedImage = $(this).attr('src');
      self.cropped = selectedImage;
      self.image = selectedImage;
      self.webImage = selectedImage;
      self.imagePreview = "";    
      $('#selectImagesModal').modal('hide');  
      $('.modal').css('overflow-y','auto');    
    });
    this.refresh();
  },
  created() {
    this.$validator.extend("productSizeFormat", {
      getMessage: field => `${field} must not contain special character`,
      validate: value => value.match(/^[a-zA-Z0-9_ ]*$/) !== null
    });
    this.$validator.extend("priceFormat", {
      getMessage: () => "Price must be alphanumeric",
      validate: value => value.match(/^[a-zA-Z0-9 -.]*$/) !== null
    });

    this.$validator.extend("webLinkValidate", {
      getMessage: () => "Please enter a valid url.",
      validate: value =>
        isURL(value, {
          require_tld: false,
          require_protocol: true
        }) !== false
    });
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    crop() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let options = {
        format: "jpeg",
        circle: false,
        size: { width: 1028 }
      };
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;
      });

      this.refresh();
    },

    result(output) {
      this.cropped = output;
    },
    update(val) {
      // console.log(val);
    },

    /* Close Modal */
    cancelAdd() {
      $("#create").modal("hide");
    },

    /* Add Gift */
    addGiftMethod(e) {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.showSpinner = true;
          this.disabled = true;
          this.buttonText = "Adding Gift...";
          if (this.cropped) {
            this.uploadGiftImage();
          } else {
            this.saveAddedGift();
          }
        }
      });
    },

    handleFileUpload() {
      this.imagePreview = null;
      this.cancelImage = false;
      this.cropped = null;
      /*
      Set the local file variable to what the user has selected.
    */
      this.file = this.$refs.file.files[0];

      /*
      Initialize a File Reader object
    */
      let reader = new FileReader();

      /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
          this.$refs.file.value = "";
          this.initCroppie();
          this.$refs.croppieRef.bind({
            url: this.imagePreview,
            zoom: 0.2
          });
        }.bind(this),
        false
      );

      /*
      Check to see if the file is not empty.
    */
      if (this.file) {
        /*
        Ensure the file is an image file.
      */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
          reader.readAsDataURL(this.file);
          this.file = "";
        }
        this.refresh();
      }
    },
    refresh() {
      if (this.$refs.croppieRef) {
        this.$refs.croppieRef.destroy();
      }
    },
    initCroppie() {
      this.$refs.croppieRef.initCroppie();
    },

    /* upload gift image */
    uploadGiftImage() {
      const uploadBody = {
        image: this.cropped
      };
      if (this.cropped) {
        this.$store
          .dispatch(UPLOAD_GIFT_IMAGE, uploadBody)
          .then(response => {
            if (response.status == 200) {
              this.image = response.data.data.file;
            } else {
              this.showSpinner = null;
              this.disabled = false;
              this.apiErrorMessage = response.data.message;
              this.apiSuccessMessage = null;
              this.buttonText = "+ Add Gift";
            }
            this.showAlert();
            this.saveAddedGift();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    saveAddedGift() {
      const body = {
        productName: this.giftName,
        productQuantity: this.buyQty,
        want: this.want === "" ? "No Preference" : this.want
      };
      body.isCustomGift = true; //add custom gift
      if (this.webImage != null) {
        this.image = this.webImage;
        if (this.image.indexOf("http:") == -1 && this.image.indexOf("https:") == -1) {
          this.image = "http:" + this.image;
        }
      }
      if (this.image) {
        body.productImage = [{ image: this.image }];
      }
      if (this.buydetails) body.detail = this.buydetails;

      if (this.buyPlace) body.whereToBuy = this.buyPlace;

      if (this.buyColor) body.productColor = this.buyColor;

      if (this.buySize) body.productSize = this.buySize;

      if (this.buyPrice) body.productPrice = this.buyPrice;

      var giftDetails = {
        wishlistId: this.$route.params.id,
        giftBody: body
      };

      this.$store
        .dispatch(ADD_GIFT, giftDetails)
        .then(response => {
          if (response.status == 200) {
            this.apiSuccessMessage = response.data.message;
            this.apiErrorMessage = null;
            // this.$store.dispatch(SET_GIFT_DETAILS, '')
            // // this.closeModal();
            // this.addCustomGift = true;
            // this.searchGiftFromWeb = true;
            // if(this.addCustomGift && this.searchGiftFromWeb) {
            //   $("#create").modal("hide");
            // }
            // setTimeout(() => {
            //   this.$router.go({ path: "Wishlist Details" });
            // }, 1000);

            this.$router.go(this.$router.currentRoute);
          } else {
            this.apiErrorMessage = response.data.message;
            this.apiSuccessMessage = null;
          }
          //reset params
          this.apiSuccessMessage = null;
          this.apiErrorMessage = null;
          this.showSpinner = null;
          this.disabled = false;
          this.buttonText = "+ Add Gift";
        })
        .catch(error => {
          this.apiErrorMessage = error.response.data.message;
          this.apiSuccessMessage = null;
          this.disabled = false;
          this.buttonText = "+ Add Gift";
        });
    },
    resetGiftForm() {
      if (document.getElementById("addGift")) {
        document.getElementById("addGift").reset();
      }
      this.giftName = "";
      this.buyPlace = "";
      this.buyColor = "";
      this.buySize = "";
      this.buyQty = "";
      this.buyPrice = "";
      this.buydetails = "";
      this.apiSuccessMessage = null;
      this.apiErrorMessage = null;
      this.want = "";
      this.image = "";
      (this.buttonText = "+ Add Gift"), (this.cropped = null);
      this.showPreview = false;
      this.imagePreview = null;
      this.searchGiftFromWeb = false;
      this.addCustomGift = false;
      this.webLink = null;
      this.showSpinner = false;

      this.refresh();
    },

    // showModal() {
    //   return (this.show === true)
    //     ? $("#create").modal("show")
    //     : $("#create").modal("hide");
    // },

    // closeModal() {
    //   // this.$emit("closeOptionModal");
    //   this.$emit("closeAddGiftModal");
    //   this.searchGiftFromWeb = false;
    //   this.addCustomGift = false;
    // },

    searchGift() {
      this.searchGiftFromWeb = true;
      this.addCustomGift = false;
    },
    customGift() {
      this.addCustomGift = true;
      this.searchGiftFromWeb = false;
    },
    addGiftFromWeb() {
      this.showSpinner = false;
      this.apiErrorMessage = null;
      this.apiSuccessMessage = null;
      const metaBody = { url: this.webLink };

      if (this.webLink) {
        // or choose a different name for it if you want to keep the old one.

        this.$validator
          .validateAll()
          .then(valid => {
            if (valid) {
              this.buttonText = "Adding gift...";
              this.showSpinner = true;
              this.disabled = true;

              /** search gift from web, scrape meta data
               * @param metaBody object with url to search
               */
              this.$store
                .dispatch(GET_META_DATA, metaBody)
                .then(response => {
                  console.log(response);
                  if (response.status == 200) {
                    
                    let jsonData = response.data.data;

                    if (jsonData.image) {
                      this.selectImages = jsonData.image;
                       // no backdrop
                       $('#selectImagesModal').on('shown.bs.modal', function () {
                          $(".modal-backdrop.in").hide();
                       })
                      $('#selectImagesModal').modal('show');
                      /*this.cropped = jsonData.image;
                      this.image = jsonData.image;
                      this.webImage = jsonData.image;
                      this.imagePreview = "";   */                   
                    }
                    this.giftName = jsonData.title;

                    //limit detail to 250 characters
                    this.buydetails = jsonData.description.substring(0, 250);

                    this.buyPlace = this.webLink;
                    this.searchGiftFromWeb = false;
                    this.addCustomGift = true;
                  } else {
                    this.apiErrorMessage =
                      "Unable to fetch the content from this URL. Please try a different URL.";
                    this.apiSuccessMessage = null;
                  }
                  this.showSpinner = null;
                  this.disabled = null;
                  this.buttonText = "+ Add Gift";
                  this.showAlert();
                })
                .catch(error => {
                  console.log(error);
                  this.apiErrorMessage =
                    "Unable to fetch the content from this URL. Please try a different URL.";
                  this.apiSuccessMessage = null;
                  this.disabled = null;
                  this.buttonText = "+ Add Gift";
                  this.showSpinner = null;
                });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    cancelBanner() {
      this.refresh();
      this.imagePreview = null;
      this.cropped = null;
      this.cancelImage = true;
    }
  }
};
</script>
